// utils/helpers.ts
import "@adornis/validation/errors/BaseError";
import { MultipleBaseError } from "@adornis/validation/errors/MultipleBaseError";
import { constructValue, fromNetwork } from "../entities/adornisEntity";
import { errors as errorClasses } from "../metaDataStore";
var replaceAtDepth = (array, arrayDepth, mapping) => {
  if (arrayDepth > 1)
    return array.forEach((entry) => replaceAtDepth(entry, arrayDepth - 1, mapping));
  for (let index = 0; index < array.length; index++) {
    array[index] = mapping(array[index]);
  }
};
var upgradeAtDepth = (op, value, network) => {
  const copiedOp = {
    name: op.name,
    type: op.type,
    arrayDepth: () => 0
  };
  if (value === null || value === void 0)
    return value;
  replaceAtDepth(value, op.arrayDepth(), (v) => {
    if (v && typeof v === "object")
      v[fromNetwork] = network;
    return constructValue(v, copiedOp);
  });
};
var mapErrorsToBaseErrors = (errors) => errors.map((err) => {
  const errorClass = errorClasses.find((c) => c._class === err.extensions?._class);
  if (!errorClass)
    return err;
  return errorClass.createFromDetails(err.message, err.extensions);
});
var combineErrors = (errors) => {
  const mappedErrors = mapErrorsToBaseErrors(errors);
  if (mappedErrors.length === 1)
    return mappedErrors[0];
  return new MultipleBaseError(mappedErrors);
};
var createModifier = (newData, oldData) => {
  const $set = {};
  const $push = [];
  let hasPush = false;
  const recurse = (obj, old, currentKey) => {
    for (const key in obj) {
      const value = obj[key];
      const oldValue = old[key];
      const newKey = currentKey ? currentKey + "." + key : key;
      if (value && typeof value === "object" && !(value instanceof Date) && oldValue) {
        recurse(value, oldValue, newKey);
        if (Array.isArray(value) && Array.isArray(oldValue) && value.length < oldValue.length) {
          $push.push({ [newKey]: { $each: [], $slice: value.length } });
          hasPush = true;
        }
      } else {
        $set[newKey] = value;
      }
    }
  };
  recurse(newData, oldData);
  return hasPush ? { $set, $push } : { $set };
};
export {
  combineErrors,
  createModifier,
  replaceAtDepth,
  upgradeAtDepth
};
